import { render, staticRenderFns } from "./HeaderLinkButton.vue?vue&type=template&id=3d697c66"
import script from "./HeaderLinkButton.vue?vue&type=script&lang=js"
export * from "./HeaderLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports